import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const { apiUrl, PORT, version } = require('../../environment');

const styles = {
  body: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    margin: 0,
    backgroundColor: '#f8f9fa',
  },
  consentContainer: {
    backgroundColor: 'white',
    padding: '2.5rem',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    textAlign: 'center' as const,
    maxWidth: '400px',
    width: '100%',
  },
  h1: {
    marginBottom: '0.5rem',
    fontSize: '1.5rem',
  },
  p: {
    marginTop: 0,
    marginBottom: '1.5rem',
    color: '#6c757d',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
  },
  button: {
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 500,
    transition: 'background-color 0.2s',
  },
  allowButton: {
    backgroundColor: '#007bff',
    color: 'white',
  },
  denyButton: {
    backgroundColor: '#e9ecef',
    color: '#212529',
  },
};

const Consent: React.FC = () => {
    const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const integrationSessionId = urlParams.get('integration_session_id');

  const handleConsent = (consentValue: 'allow' | 'deny') => {
    if (!integrationSessionId) {
      console.error('No integration session ID found.');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No authentication token found.');
      // Optionally, redirect to login page
      navigate('/login');
      return;
    }

    const consentUrl = new URL(`${apiUrl}${PORT}${version}/oauth/consent`);
    consentUrl.searchParams.append('integration_session_id', integrationSessionId);
    consentUrl.searchParams.append('consent', consentValue);
    consentUrl.searchParams.append('token', token);

    window.location.href = consentUrl.toString();
  };

  if (!integrationSessionId) {
    return (
      <div style={styles.body}>
        <div style={styles.consentContainer}>
          <h1 style={styles.h1}>Error</h1>
          <p style={styles.p}>No integration session ID found. Please start the connection process again.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.body}>
      <div style={styles.consentContainer}>
        <h1 style={styles.h1}>Authorize Application</h1>
        <p style={styles.p}><strong>My Test App</strong> wants permission to access your ReferUs account.</p>
        <div style={styles.buttons}>
          <button style={{...styles.button, ...styles.denyButton}} onClick={() => handleConsent('deny')}>Deny</button>
          <button style={{...styles.button, ...styles.allowButton}} onClick={() => handleConsent('allow')}>Allow</button>
        </div>
      </div>
    </div>
  );
};

export default Consent;
